export enum CourseColor {
  Yellow = "yellow",
  MutedYellow = "muted-yellow",
  MutedGreen = "muted-green",
  Green = "green",
  Turquoise = "turquoise",
  MutedTurquoise = "muted-turquoise",
  MutedCyan = "muted-cyan",
  Cyan = "cyan",
  Blue = "blue",
  MutedBlue = "muted-blue",
  MutedPurple = "muted-purple",
  Purple = "purple",
  Pink = "pink",
  MutedPink = "muted-pink",
  MutedCoral = "muted-coral",
  Coral = "coral",
}

export type CcColors =
  | "yellow"
  | "muted-yellow"
  | "muted-green"
  | "green"
  | "turquoise"
  | "muted-turquoise"
  | "muted-cyan"
  | "cyan"
  | "blue"
  | "muted-blue"
  | "muted-purple"
  | "purple"
  | "pink"
  | "muted-pink"
  | "muted-coral"
  | "coral"
